//
//
//
//
//
//
//
//

export default {
  name: 'FormInput',
  props: {
    value: {
      type: [ String, Number, Boolean ],
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    placeholder: String,
    type: {
      type: String,
      default: 'text'
    },
    required: Boolean,
    regexp: [ RegExp, Object ]
  },
  created () {
    this.val = this.value
  },
  mounted () {},
  data () {
    return {
      showErrorFlag: false,
      errorInfo: '',
      val: ''
    }
  },
  computed: {},
  watch: {
    value (v) {
      this.val = v
    },
    val (v) {
      this.validate()
      this.$emit('input', v)
    }
  },
  filters: {},
  methods: {
    validate () {
      this.showErrorFlag = false
      this.errorInfo = ''
      if (this.required && this.val === '') {
        this.showErrorFlag = true
        this.errorInfo = `${this.name}不能为空`
        return false
      }
      if (this.val && this.regexp && this.regexp instanceof RegExp && !this.regexp.test(this.val)) {
        this.showErrorFlag = true
        this.errorInfo = `格式错误`
        return false
      }
      return true
    }
  }
}
